import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'aa-popin-title',
    templateUrl: './popin-title.component.html',
    styleUrls: [
        './popin-title.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PopinTitleComponent
{
    @Input() title: string = '';
}
